const twoFactorAuthNL = {
    "view": {
        "title": "Twee-factor authenticatie",
        "form": {
            "label": {
                "currentMethod": "Huidige twee-factor methode",
                "authenticatorSetupTitle": "Stel uw Authenticator-app in",
                "scanInstructions": "Scan de QR-code hieronder met een TOTP Authenticator-app (zoals Authy, Google Authenticator, Microsoft Authenticator etc.).",
                "qrCodeAlt": "QR-code voor authenticator installatie",
                "step1": "Open uw authenticator-app.",
                "step2": "Selecteer de optie om een nieuw account toe te voegen.",
                "step3": "Kies de optie \"Scan een QR-code\" in de app.",
                "step4": "Richt de camera van uw telefoon op de QR-code hierboven.",
                "step5": "Na het scannen begint de authenticator met het genereren van een 6-cijferige OTP-code die elke 30 seconden vernieuwt. Deze OTP-code kan worden gebruikt om het inlogproces te voltooien.",
                "appLinks": "Hier zijn de links voor enkele veelgebruikte authenticator-apps:",
                "appLinksAuthy": "Authy",
                "appLinksGoogle": "Google Authenticator",
                "appLinksMicrosoft": "Microsoft Authenticator",
                "googlePlay": "Google Play Store",
                "appStore": "Apple App Store",
                "loadingQrCode": "QR-code laden...",
                "emailSetupTitle": "E-mail twee-factor authenticatie",
                "emailDescription": "U ontvangt een eenmalig wachtwoord (OTP) op uw geregistreerde e-mailadres, dat kan worden gebruikt om het inlogproces te voltooien. Zorg ervoor dat u uw e-mailinbox of spammap controleert voor de OTP bij het inloggen."
            },
            "help_text": {
                "currentMethod": "E-mail is momenteel ingesteld als de standaardmethode voor twee-factor authenticatie. We raden echter aan om de Authenticator-methode te gebruiken voor verbeterde beveiliging."
            },
            "option": {
                "2faMethod": {
                    "selectMethod": "Selecteer 2FA-methode",
                    "email": "E-mail",
                    "auth": "Authenticator"
                }
            },
            "button": {
                "save": "Opslaan",
                "saving": "Opslaan..."
            }
        },
        "backupCodes": {
            "title": "Back-upcodes",
            "view": {
                "button": {
                    "generate": "Genereer back-upcodes",
                    "download": "Download back-upcodes"
                },
                "modal": {
                    "header": "Uw back-upcodes",
                    "body": {
                        "noCodes": "Geen back-upcodes beschikbaar"
                    }
                }
            }
        }
    }
};

export default twoFactorAuthNL;